export const userRequestKey = 'user';

export const medicalUnitRequestKey = 'medicalUnit';

export const userAffiliationRequestKey = 'userAffiliation';
